import React from "react";
import { Card } from 'react-bootstrap';
import { Row, Col } from 'react-bootstrap';
// import { Container } from 'react-bootstrap';
import './Services.css';
// import './ServicesV.css';

import consultbg from '../images/PageImg/ServiceConsult-page-bg.jpg'
import HeaderSlide from '../components/HeaderSlide'
import { ServConsultImg } from "../assets/ServConsultData";
import { ServConsultTxt } from "../assets/ServConsultData";

import { GoTopBtn } from '../components/GoTopBtn';

function ServiceConsult() {
  // console.log("get into function ServConsult()");
  return (
    <div className='services-page container-fluid'>
      <div className='serviceheader'
        style={{ backgroundImage: `url(${consultbg})`, height: "65vh" }} >
        <HeaderSlide text={'Service / Consulting'} />
        <h4 className='text-dark'>&nbsp;images/PageImg/ServiceConsult-page-bg.jpg</h4>
      </div>
      {/* <br /> */}

      {/* Service / Consulting */}
      <section id='servconsult' className='block service-block bg-primary-subtle'>
        {/* <h2 className='title-holder fs-1 fw-bold text-success'>Service / Consulting</h2> */}
        <h2 className='title-holder fs-1 fw-bold text-primary'>Service / Consulting</h2>
        {/* <Container fluid> */}
        <Row>
          <Col lg={5} className='flex-column justify-content-center'> {
            ServConsultImg.map(idx => {
              return (
                <Row key={idx.id} className='d-flex'>
                  <img src={idx.image} style={{ height: 'auto' }} alt='' />
                  {/* <img style={{ width: '40vw' }} src={idx.image} alt='' /> */}
                  <h5 className='text-warning-emphasis'>{idx.alt}</h5>
                </Row>
              );
            })
          } </Col>
          <Col lg={7} className='d-flex flex-column justify-content-around'> {
            <Row> {
              ServConsultTxt.map(consult => {
                return (
                  <Row key={consult.id} className='holder'>
                    <Card className='bg-info-subtle border-1 p-0 m-0'>
                      <br />
                      <Card.Title className='fs-2 text-center text-primary'> {consult.title} </Card.Title>
                      <Card.Text style={{ whiteSpace: 'pre' }}> {consult.text} </Card.Text>
                      {/* <Card.Text className='fs-2 text-center'> {consult.subtitle} </Card.Text> */}
                    </Card>
                  </Row>
                )
              })
            } </Row>
          } </Col>
        </Row>
        {/* </Container> */}
      </section>

      <div> < GoTopBtn /> </div>
    </div>
  );
}

export default ServiceConsult;

// import { ServConsultTopTxt } from "../assets/ServConsultData";
// import { ServConsultTopImg } from "../assets/ServConsultData";

// {/* Service Consulting Header */}
// {/* <Container className='d-flex justify-content-center align-items-center'> */}
// <Container fluid className='d-flex'>
//   <header className='mt-1'>
//     <h1 className='servconsult'>Service / Consulting</h1>
//     <h5 className='text-warning'>PageImg/services-page.jpg</h5>
//     <h5 className='text-warning'>ServiceImg/ServConsult.jpg</h5>
//   </header>
// </Container>
// {/* Service Consult Top Image */}
// <section id='servconsulttop' className='block service-block bg-success-subtle'>
//   <Container fluid>
//     <h2 className='title-holder fs-1 fw-bold text-primary'>Service / Consulting</h2>
//     <Row className='d-flex justify-content-around'> {
//       ServConsultTopImg.map(idx => {
//         return (
//           <Col lg={3} key={idx.id} className='flex'>
//             <img src={idx.image} style={{ height: 'auto', width: '40vw' }} alt='' />
//             // <img src={idx.image} style={{ height: '40vh', width: '40vw' }} alt='' />
//             <h5 className='text-danger-emphasis'>{idx.alt}</h5>
//           </Col>
//         )
//       })
//     } </Row>
//   </Container>
// </section>

// {/* Service Consulting */}
// <section id='servconsulttop' className='block service-block bg-primary-subtle'>
//   <h2 className='title-holder fs-1 fw-bold text-primary'>Service / Consulting</h2>
//   <Container fluid>
//     <Row>
//       <Col lg={3} className='flex-column'> {
//         ServConsultImg.map(idx => {
//           return (
//             <Row key={idx.id} className='d-flex'>
//               <img style={{ width: '60vw' }} src={idx.image} className='img-fluid' alt={idx.alt} />
//               <h5 className='text-warning-emphasis'>{idx.alt}</h5>
//             </Row>
//           )
//         })
//       } </Col>
//       <Col lg={9} className='d-flex flex-column justify-content-around'>
//         <Row> {
//           ServConsultTxt.map((consult) => {
//             return (
//               <Row key={consult.id} className='holder'>
//                 <Card className='bg-warning-subtle border-1 p-0 m-0'>
//                   <br />
//                   <Card.Title className='text-center fs-2 text-primary'> {consult.title} </Card.Title>
//                   <Card.Text className='fs-2 text-center text-primary'> {pcap.subtitle} </Card.Text>
//                   <Card.Text style={{ whiteSpace: 'pre' }}> {consult.text} </Card.Text>
//                 </Card>
//               </Row>
//             )
//           })
//         } </Row>
//       </Col>
//     </Row>
//   </Container>
// </section >